import {combineReducers} from 'redux';
import company from './company';
import role from './role'
import isLogin from './isLogin';
export default combineReducers({
    company,
    role,
    isLogin
});